/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  webpage,
  eventService,
  changesService,
  organizationService,
  OrganizationExchange,
  uiService
) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    $q.all([organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id })])
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.exchange = OrganizationExchange.build(data[0].exchange);
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Marketing : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () =>
    organizationService
      .updateOrganization({
        id: $rootScope.CurrentOrganization.id,
        exchange: $rootScope.CurrentOrganization.exchange
      })
      .then((result) => {
        if (result.status) {
          changesService.resetChanges();
        } else {
          uiService.toast({
            text: {
              p1: 'Failed to',
              p2: 'save',
              p3: 'your changes'
            },
            warn: true
          });
        }
        return { status: !!result.status };
      });

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
